import { createFeatureSelector } from "@ngrx/store";
import * as fromLogging from "./logging.reducer";

export const selectLoggingState =
  createFeatureSelector<fromLogging.LoggingState>(
    fromLogging.loggingFeatureKey,
  );
